export const GET_SUPERUSER= 'GET_SUPERUSER'
export const GET_SUPERUSER_SUCCESS= 'GET_SUPERUSER_SUCCESS'
export const GET_SUPERUSER_ERROR='GET_SUPERUSER_ERROR'

export const GetSuperUser= (data) => ({
    type: GET_SUPERUSER,
    payload: data
})